<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-03-19 16:14:26
 * @Description: 甘特图右侧下方区横道间关系连接线组件
-->

<template>
  <div class="gantt-line" :style="getHeight" v-show="getLinesArr.length > 0">

    <!-- 任务块组合连线 -->
    <div class="task-line-box">
      <template v-for="(item, itemIndex) in getLinesArr">
        <div
          class="task-line-item"
          :data-key="`${item.s_index}_${item.e_index}_${item.t_w}_${item.t_h}_${item.type}_${itemIndex}`"
          :key="`${item.s_index}_${item.e_index}_${item.t_w}_${item.t_h}_${item.type}_${itemIndex}`"
          :style="`
                    width: ${item.t_w}px;
                    height: ${item.t_h}px;
                    left: ${item.s_x}px;
                    top: ${item.s_y}px;
                    ${(item.type === 4)? 'transform:rotate(' + item.e_w + 'deg)': ''}
                  `"
          :class="{
            'act-line': actLine == itemIndex
          }"
          :data-type="item.type"
        >
          <!-- 一字型 -->
          <template v-if="item.type == 4">
            <div
              class="task-line-1-xline"
              :style="`width: ${item.t_w}px;`"
            >
              <div class="task-line-1-xline-show"></div>
              <div class="task-line-arrow" v-show="item.t_w >= 6"></div>
            </div>
          </template>
          <!-- 三叉戟型 -->
          <template v-else-if="item.type == 1 && item.t_h > 8">
            <div
              class="task-line-3x-s1"
              :class="{
                'line-left': item.pos_s1 === 1,
                'line-right': item.pos_s1 === -1,
              }"
              :style="{
                'height': item.h_s1 + 'px',
              }"
            >
              <div class="task-line-3x-s1-show task-line-shadow"></div>
              <div
                v-if="item.direction_Y < 0"
                class="task-line-3x-arrow"
              ></div>
            </div>
            <div
              class="task-line-3x-mid"
              :style="{
                'margin-top': item.h_s1 - 1 + 'px',
              }"
            >
              <div class="task-line-3x-mid-show task-line-shadow"></div>
            </div>
            <div
              class="task-line-3x-s2"
              :class="{
                'line-left': item.pos_s2 === 1,
                'line-right': item.pos_s2 === -1,
              }"
              :style="{
                'height': item.h_s2 + 'px',
              }"
            >
              <div class="task-line-3x-s2-show task-line-shadow"></div>
              <div
                v-if="item.direction_Y > 0"
                class="task-line-3x-arrow"
              ></div>
            </div>
          </template>

        </div>
      </template>

    </div>
  </div>

</template>

<script>
export default {
  name: "GtLinesPlus",
  data() {
    return {
      actLine: -1, // 选中的线
    };
  },
  props: {
    barsCSSInfo: {
      type: Array,
      default: () => { return []; },
    },
    totalHeight: {
      type: Number,
      default: () => { return 0; },
    },
  },
  computed: {
    // 换算连线关系数组
    getLinesArr: function() {
      const _self = this;
      const result = [];
      const taskPosInfoArr = this.barsCSSInfo;
      if (taskPosInfoArr && taskPosInfoArr.length > 0) {
        const _taskArr = _self.$utils.deepClone(taskPosInfoArr);
        // 起始分类
        for (let i = 0; i < _taskArr.length; i++) {
          const a = taskPosInfoArr[i]; // 任务起点坐标信息
          const _lineArr = _taskArr[i].taskLink;
          let _line;
          for (let n = 0; n < _lineArr.length; n++) {
            const _item = _lineArr[n];
            const endRowIndex = _self.$utils.fnGetIndex(_item.taskLinkId, taskPosInfoArr, "_id"); // 目标id的下标
            if (endRowIndex != -1) {
              const b2 = taskPosInfoArr[endRowIndex];
              if (a._width <= 0 || b2._width <= 0) {
                console.warn("连线关系: 横道宽度异常", a, b2);
                continue;
              }
              _line = _self.getLinesItemInfo(_item.startLinePosType, _item.endLinePosType, a, b2, i, endRowIndex);
              _line && result.push(_line);
            }
          }

        }
        // console.log("连线关系+：", result);
      }
      return result;
    },
    getHeight() {
      let ganttBgCss = "";
      if (this.totalHeight === 0) {
        ganttBgCss = "";
      } else {
        ganttBgCss = {
          "height": this.totalHeight + "px",
        };
      }
      return ganttBgCss;
    },
  },
  methods: {
    /**
     * @description: 换算单个连线关系
     * @param {_startType: 起点a方向左右}
     * @param {_endType: 终点b方向左右}
     * @param {posInfoA: 起点坐标}
     * @param {posInfoB: 终点坐标}
     * @param {sIndex: 起点索引}
     * @param {eIndex: 终点索引}
     * @return {
        s_type: 'pre'左起点 | 'next'右起点
        e_type: 'pre'左终点 | 'next'右终点
        s_x: 连线块起点x
        s_y: 连线块起点y
        direction_x: 1 朝右 | -1 朝左
        direction_Y: 1 朝下 | -1 朝上
        t_w: 连线块总宽
        t_h: 连线块总高
        _mid_w: _mid_w, // 横线宽度
        h_s1: 12, // 由上而下第一段高度 举例12
        h_s2: t_h - 12, // 由上而下第二段高度
        pos_s1: -1, // 由上而下第一段左右位置1左 -1右
        pos_s2: 1, // 由上而下第二段左右位置1左 -1右
        type: 1:【】型 | 2: Z型(制造暂时废弃) | 3: 已字型 | 4: 一字型 | 5: 7+1字型
        s_index: 起点索引
        e_index: 终点索引
      }
    */

    getLinesItemInfo(_startType, _endType, posInfoA, posInfoB, sIndex, eIndex) {
      const _self = this;
      const b = posInfoB; // {_top: 7,_left: 360,_width: 80,_id: 2,...task}
      const a = posInfoA; // {_top: 42,_left: 200,_width: 80,_id: 1,...task}
      // const _baseWidth = this.$store.getters.cellWidth / 2;
      // const num = _baseWidth > 30 ? _baseWidth : 30; // 起点左右拓展基础值 30

      const _cellHeight = this.$store.state.cellHeight; // 50;
      const _taskHeight = this.$store.state.taskHeight; // 20;
      const startType = _startType; // 'pre'
      const endType = _endType; // 'pre'
      // const ind = eIndex; // '被连接任务的位置信息的索引 || 任务信息索引'
      // console.log("连接关系:", a, b, sIndex, startType, "-->", ind, endType);

      let _sx = 0;
      let _sy = 0;
      let _dx = 1;
      let _tw = 0;
      let _mid_w = 0;
      let _th = 0;
      let _sh = 0;
      let _eh = 0;
      let _dy = 1;
      let _type = 1;
      const startRightPoint = (a._left + a._width); // 开始点右端点
      const endRightPoint = (b._left + b._width);// 结束点右端点
      let _topItem, _botItem; // 靠上横道对象 靠下横道对象
      _dy = (a._top > b._top ? -1 : 1);
      /* 新增·一字型 */
      if (
        (
          a._top > 0 &&
          b._top > 0 &&
          (a.groupId == b.groupId && a.curRow === b.curRow)
        ) ||
        (
          a._top > b._top &&
          a._top + (a.crossObjName == "task" && a.crossHeightVal > 0 ? a.crossHeightVal : _taskHeight) <
          b._top + (b.crossObjName == "task" && b.crossHeightVal > 0 ? b.crossHeightVal : _taskHeight)
        ) ||
        (
          a._top < b._top &&
          (a._top + (a.crossObjName == "task" && a.crossHeightVal > 0 ? a.crossHeightVal : _taskHeight)) >
          (b._top + (b.crossObjName == "task" && b.crossHeightVal > 0 ? b.crossHeightVal : _taskHeight))
        )
      ) {
        // console.log("类型：一字型");

        const _aHeight = a.crossObjName == "task" ? a.crossHeightVal : _taskHeight;
        const _bHeight = b.crossObjName == "task" ? b.crossHeightVal : _taskHeight;
        // _sy = a._top - _aHeight / 2 + _taskHeight / 2;
        _sy = a._top + _aHeight / 2 - _taskHeight / 2;
        _type = 4;
        let _startPoint;
        let _endPoint;
        if (startType == "next") {
          _startPoint = startRightPoint;
          if (endType == "next") {
            _endPoint = endRightPoint;
          } else {
            _endPoint = b._left;
          }
        } else {
          _startPoint = a._left;
          if (endType == "next") {
            _endPoint = endRightPoint;
          } else {
            _endPoint = b._left;
          }
        }
        const baseWidth = _endPoint - _startPoint; // 三角变换前的宽
        const baseHeight = (b._top + _bHeight / 2) - (a._top + _aHeight / 2); // 三角变换前的高

        let _deg; // 角度
        const getDeg = _self.$utils.getDeg;
        if (baseWidth > 0) {
          if (baseHeight > 0) {
            _deg = -1 * getDeg(baseWidth, baseHeight);
          } else if (baseHeight == 0) {
            _deg = -90;
          } else {
            _deg = -(180 - getDeg(baseWidth, baseHeight));
          }
        } else if (baseWidth == 0) {
          if (baseHeight > 0) {
            _deg = 0;
          } else if (baseHeight == 0) {
            _deg = 0;
          } else {
            _deg = -180;
          }
        } else {
          if (baseHeight > 0) {
            _deg = getDeg(baseWidth, baseHeight);
          } else if (baseHeight == 0) {
            _deg = 90;
          } else {
            _deg = 180 - getDeg(baseWidth, baseHeight);
          }
        }
        _deg += 90;

        _dx = (_startPoint >= _endPoint ? -1 : 1);
        _tw = Math.sqrt(Math.pow(baseWidth, 2) + Math.pow(baseHeight, 2));
        const demo = {
          s_type: startType, // 'pre'左起点,'next'右起点
          e_type: endType, // 'pre'左终点,'next'右终点
          s_x: _startPoint, // 连线块起点x
          s_y: _sy, // 连线块起点y
          // s_w: baseHeight, // ***一字型用来做判断是否需要旋转变换 0 不需要变换***
          e_w: _deg, // ***一字型用来记录 旋转角度***
          direction_x: _dx, // 1 朝右 -1 朝左
          direction_Y: (_aHeight > _bHeight ? 1 : -1), // 1 朝下 -1 朝上
          t_w: _tw, // 连线块总宽
          t_h: _taskHeight, // 连线块总高
          _mid_w: 0,
          h_s1: 0,
          h_s2: 0,
          pos_s1: -1,
          pos_s2: 1,
          type: _type, // [1: 三叉戟型,4: 一字型,]
          s_index: sIndex, // 起点索引
          e_index: eIndex, // 终点索引
        };
        return demo;
      } else if (a._top < b._top) {
        _topItem = a;
        _botItem = b;
      } else {
        _topItem = b;
        _botItem = a;
      }

      const _topHeight = _topItem.crossObjName == "task" && _topItem.crossHeightVal > 0 ? _topItem.crossHeightVal : _taskHeight;
      const _botHeight = _botItem.crossObjName == "task" && _botItem.crossHeightVal > 0 ? _botItem.crossHeightVal : _taskHeight;

      _th = Math.abs(_botItem._top - _topItem._top - _topHeight);
      _sh = (_dy > 0 ? (_cellHeight - _taskHeight) / 2 : _th - (a._top % _cellHeight)) - 1;// 上半截高度
      _eh = _th - _sh; // 下半截高度

      const _borderRadiusWidth = this.$store.state.viewSchem.noTaskBorderRadiusShow ? 0 : 2; // 圆角额外偏移
      const _diffX_a = a.crossObjName === "landmarks" ? (_taskHeight / 2) : _borderRadiusWidth; // 处理圆角空缺,里程碑10
      const _diffX_b = b.crossObjName === "landmarks" ? (_taskHeight / 2) : _borderRadiusWidth; // 处理圆角空缺,里程碑10
      let _startPoint_base = 0; // 原始起点
      let _startPoint = 0; // 偏移起点
      let _endPoint_base = 0; // 原始终点
      let _endPoint = 0; // 偏移终点
      const arrowWidth = 8 / 2; // 箭头一半的尺寸
      if (startType == "pre") {
        _startPoint_base = a._left;
        _startPoint = _startPoint_base + _diffX_a; // 渲染线起点
      } else {
        _startPoint_base = startRightPoint;
        _startPoint = _startPoint_base - _diffX_a;
      }
      if (endType == "pre") {
        _endPoint_base = b._left;
        _endPoint = _endPoint_base + _diffX_b; // 渲染线起点
      } else {
        _endPoint_base = endRightPoint;
        _endPoint = _endPoint_base - _diffX_b;
      }
      _dx = _startPoint <= _endPoint ? 1 : -1; // _dx = _startPoint_base <= _endPoint_base ? 1 : -1;
      const _base_w = Math.abs(_startPoint - _endPoint); // 原始俩点x轴差值
      _tw = _base_w + arrowWidth * 2; // 箭头占位扩展 8 / 2 * 2
      // const _dx_t1 = (_dx > 0 && _dy > 0) || (_dx < 0 && _dy < 0) ? 1 : -1;
      const _dx_t1 = (_dx == _dy) ? 1 : -1;
      const _dx_t2 = _dx_t1 * -1;

      _mid_w = Math.abs(_endPoint - _startPoint);
      _sx = Math.min(_startPoint, _endPoint) - arrowWidth;
      _sy = _topItem._top + _topHeight;
      const demo = {
        s_type: startType, // 'pre'左起点,'next'右起点
        e_type: endType, // 'pre'左终点,'next'右终点
        s_x: _sx, // 连线块起点x
        s_y: _sy, // 连线块起点y
        direction_x: _dx, // 1 朝右 -1 朝左
        direction_Y: _dy, // 1 朝下 -1 朝上
        t_w: _tw, // 连线块总宽
        t_h: _th, // 连线块总高
        _mid_w: _mid_w, // 横线宽度
        h_s1: _sh, // 由上而下第一段高度
        h_s2: _eh, // 由上而下第一段高度
        pos_s1: _dx_t1, // 由上而下第一段左右位置1左 -1右
        pos_s2: _dx_t2, // 由上而下第二段左右位置1左 -1右
        type: _type, // [1:三叉戟型,4: 一字型]
        s_index: sIndex, // 起点索引
        e_index: eIndex, // 终点索引
      };
      return demo;
    },

  },
};
</script>

<style scoped lang='less'>
@import './GtLinesPlus.less';

</style>
